import React from "react";
import { Switch } from 'react-router-dom';
import { errorLayout } from '../../layouts/ErrorLayout';
import PublicLayout from '../../layouts/PublicLayout/PublicLayout';
import AppRoute from '../AppRoute';
import Loader from '../../helper/loaders';
import DashboardLayout from '../../layouts/DashboardLayout/DashboardLayout';
import AuthLayout from "../../layouts/AuthLayout/AuthLayout";

const Login = Loader(() =>
    import(/* webpackChunkName: "NotFoundPage" */ '../../containers/Signin/Signin')
);

const NotFoundPage = Loader(() =>
    import(/* webpackChunkName: "NotFoundPage" */ '../../containers/not-found-page.component')
);

const SignUp = Loader(() =>
    import(/* webpackChunkName: "NotFoundPage" */ '../../containers/Signup/Signup')
);

// const TextEditor = Loader(() =>
//     import(/* webpackChunkName: "NotFoundPage" */ '../../containers/Legals/TextEditor')
// );

const ForgotPassword = Loader(() =>
    import(/* webpackChunkName: "NotFoundPage" */ '../../containers/Password/ForgotPassword')
);

const ResetPassword = Loader(() =>
    import(/* webpackChunkName: "NotFoundPage" */ '../../containers/Password/ResetPassword')
);

const Profile = Loader(() =>
    import(/* webpackChunkName: "NotFoundPage" */ '../../containers/Profile/Profile')
);

const ChargeCard = Loader(() =>
    import(/* webpackChunkName: "NotFoundPage" */ '../../containers/Signup/ChargeCard')
);

const Billing = Loader(() =>
    import(/* webpackChunkName: "NotFoundPage" */ '../../containers/Profile/Billing')
);

const Receipt = Loader(() =>
    import(/* webpackChunkName: "NotFoundPage" */ '../../containers/Profile/InvoiceReceipt')
);

const AuthComponent = (props) => {
    let { match } = props;

    return (
        <React.Fragment>
            <Switch>

                <AppRoute
                    path={`${match.path}/login:sessexpire?`}
                    component={Login}
                    layout={PublicLayout}
                    type='public'
                    title='Login'
                />

                <AppRoute
                    exact={true}
                    path={`${match.path}/signup`}
                    component={SignUp}
                    layout={PublicLayout}
                    type='public'
                    title='Signup'
                />
                {/* <AppRoute
                    exact={true}
                    path={`${match.path}/textEditor`}
                    component={TextEditor}
                    layout={PublicLayout}
                    type='public'
                    title='TextEditor'
                /> */}

                <AppRoute
                    exact={true}
                    path={`${match.path}/forgot-password`}
                    component={ForgotPassword}
                    layout={PublicLayout}
                    type='public'
                    title='Forgot Password'
                />

                <AppRoute
                    exact={true}
                    // path={`${match.path}/reset-password`}
                    path={`${match.path}/reset-password/:email/:token`}
                    component={ResetPassword}
                    layout={PublicLayout}
                    type='public'
                    title='Reset Password'
                />

                <AppRoute
                    path={`${match.path}/profile`}
                    component={Profile}
                    layout={DashboardLayout}
                    type='public'
                    title='Profile'
                />

                <AppRoute
                    path={`${match.path}/charge-card`}
                    component={ChargeCard}
                    layout={AuthLayout}
                    type='public'
                    title='Charge Card'
                />

                <AppRoute
                    path={`${match.path}/billing`}
                    component={Billing}
                    layout={DashboardLayout}
                    type='public'
                    title='Billing'
                />

                <AppRoute
                    path={`${match.path}/invoice-receipt/:id`}
                    component={Receipt}
                    layout={PublicLayout}
                    type='public'
                    title='Invoice Receipt'
                />

                <AppRoute
                    path={`${match.path}/*`}
                    component={NotFoundPage}
                    requireAuth={() => false}
                    layout={errorLayout}
                    type='public'
                />

                <AppRoute
                    exact
                    path={`${match.path}`}
                    component={NotFoundPage}
                    requireAuth={() => false}
                    layout={errorLayout}
                    type='public'
                />

            </Switch>
        </React.Fragment>
    )
};

export default AuthComponent;